// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-term-text {
  font-size: 28px;
  font-weight: 600;
  font-family: Roboto;
}
.quick-review-text {
  color: #5b5e5d;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
}
.monitored-transparency-div {
  margin-top: 24px;
  border-radius: 5px;
  height: 118px;
  width: 100%;
  border: 1px solid #fe9920;
  background-color: #ffefdb;
}
.dos-div {
  padding-top: 15px;
  margin-top: 24px;
  border-radius: 5px;
  height: 134px;
  width: 100%;
  border: 1px solid #008342;
  background-color: #e5fff2;
}
.retrictions-text {
  font-size: 16px;
  font-weight: 600;
  font-style: Roboto;
  padding-left: 15px;
  padding-top: 15px;
}
.restiction-rules-text {
  font-size: 16px;
  font-weight: 400;
  color: #5b5e5d;
  font-family: Roboto;
}
.donts-div {
  padding-top: 15px;
  margin-top: 24px;
  border-radius: 5px;
  height: 134px;
  width: 100%;
  border: 1px solid #d2042d;
  background-color: #fedce3;
}
.accept-chat-btn {
  height: 48px;
  width: 100%;
  background-color: #d2042d;
  border: none;
}
.accept-chat-btn:hover {
  height: 48px !important;
  width: 100% !important;
  background-color: #d2042d !important;
  border: none;
}
.accept-chat-txt {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  font-family: Roboto;
}
.chat-terms-checkbox {
  font-size: 16px;
  font-weight: 400;
  font-family: Roboto;
}
.terms-chat-link {
  font-size: 16px;
  font-weight: 500;
  font-family: Roboto;
  color: #d2042d;
  text-decoration: underline;
}
@media (max-width: 768px) {
  .chat-terms-container {
    /* padding: 35px; */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/chat-terms/ChatTerms.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".chat-term-text {\n  font-size: 28px;\n  font-weight: 600;\n  font-family: Roboto;\n}\n.quick-review-text {\n  color: #5b5e5d;\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: 400;\n}\n.monitored-transparency-div {\n  margin-top: 24px;\n  border-radius: 5px;\n  height: 118px;\n  width: 100%;\n  border: 1px solid #fe9920;\n  background-color: #ffefdb;\n}\n.dos-div {\n  padding-top: 15px;\n  margin-top: 24px;\n  border-radius: 5px;\n  height: 134px;\n  width: 100%;\n  border: 1px solid #008342;\n  background-color: #e5fff2;\n}\n.retrictions-text {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: Roboto;\n  padding-left: 15px;\n  padding-top: 15px;\n}\n.restiction-rules-text {\n  font-size: 16px;\n  font-weight: 400;\n  color: #5b5e5d;\n  font-family: Roboto;\n}\n.donts-div {\n  padding-top: 15px;\n  margin-top: 24px;\n  border-radius: 5px;\n  height: 134px;\n  width: 100%;\n  border: 1px solid #d2042d;\n  background-color: #fedce3;\n}\n.accept-chat-btn {\n  height: 48px;\n  width: 100%;\n  background-color: #d2042d;\n  border: none;\n}\n.accept-chat-btn:hover {\n  height: 48px !important;\n  width: 100% !important;\n  background-color: #d2042d !important;\n  border: none;\n}\n.accept-chat-txt {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: Roboto;\n}\n.chat-terms-checkbox {\n  font-size: 16px;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.terms-chat-link {\n  font-size: 16px;\n  font-weight: 500;\n  font-family: Roboto;\n  color: #d2042d;\n  text-decoration: underline;\n}\n@media (max-width: 768px) {\n  .chat-terms-container {\n    /* padding: 35px; */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
